var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":"Cari Talent Sesuai Bisnismu 🚀"}},[_c('b-card-text',[_vm._v("Waktu adalah uang.")]),_c('b-card-text',[_vm._v("Dapatkan talent terbaik dan mulai jalankan bisnismu!.")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }